module.exports = __webpack_public_path__ + "static/media/svelte.ec686078.svg";